export default __webpack_public_path__ + "static/media/noImage.1ca82fd9.svg";